import { DateAfterSpecification } from '../../../../utils/specification/date-after-specification';
import { DateBeforeSpecification } from '../../../../utils/specification/date-before-specification';
import { DateEqualSpecification } from '../../../../utils/specification/date-equal-specification';
import { PropertySpecification } from '../../../../utils/specification/property-specification';
import { Specification } from '../../../../utils/specification/specification';
import { StringSpecification } from '../../../../utils/specification/string-specification';
import { ProductPriceCardItem } from '../models/product-price-card-item.model';
import { ProductPriceListFiltersValue } from '../models/product-price-list-filters-value';

import { PriceCustomerProductReferenceSpecification } from './price-customer-product-reference-specification';

const regexWithSpaces = /[^a-zA-Z0-9 ]/g;
const regexWithoutSpaces = /[^a-zA-Z0-9]/g;

const createSearchSpecification = (search: string, regex: RegExp): Specification<ProductPriceCardItem> =>
   new StringSpecification<ProductPriceCardItem>(search, regex, 'brandName')
      .or(new StringSpecification<ProductPriceCardItem>(search, regex, 'color'))
      .or(new StringSpecification<ProductPriceCardItem>(search, regex, 'description'))
      .or(new StringSpecification<ProductPriceCardItem>(search, regex, 'grade'))
      .or(new StringSpecification<ProductPriceCardItem>(search, regex, 'polymerType'))
      .or(new StringSpecification<ProductPriceCardItem>(search, regex, 'producerColorCode'))
      .or(new StringSpecification<ProductPriceCardItem>(search, regex, 'businessContextReference'))
      .or(new StringSpecification<ProductPriceCardItem>(search, regex, 'customerReferences'))
      .or(new PriceCustomerProductReferenceSpecification(search, regex));

export const createFilterSpecification = (filterValue: ProductPriceListFiltersValue) => {
   let specification = new PropertySpecification<ProductPriceCardItem>(filterValue.brand, 'brandName').and(
      new PropertySpecification<ProductPriceCardItem>(filterValue.polymerType, 'polymerType')
   );

   if (filterValue.orderedFromDate) {
      specification = specification.and(
         new DateAfterSpecification(filterValue.orderedFromDate, 'lastOrderedOn').or(
            new DateEqualSpecification(filterValue.orderedFromDate, 'lastOrderedOn')
         )
      );
   }
   if (filterValue.orderedUntilDate) {
      specification = specification.and(
         new DateBeforeSpecification(filterValue.orderedUntilDate, 'lastOrderedOn').or(
            new DateEqualSpecification(filterValue.orderedUntilDate, 'lastOrderedOn')
         )
      );
   }

   if (!filterValue.search) return specification;

   const words = filterValue.search.toLowerCase().replace(regexWithSpaces, '').split(' ');
   if (words.length === 1) return specification.and(createSearchSpecification(words[0], regexWithoutSpaces));
   words.forEach((word) => {
      const wordSpec = createSearchSpecification(word, regexWithSpaces);
      specification = specification.and(wordSpec);
   });

   return specification;
};
